import React, { Component } from 'react';

class Footer extends Component {
  
  render() {
    var dt = new Date();  
    return (
      <footer className="fixed-bottom site-footer site-footer--minimal">
         <div className="l-container l-container--inner">
            <div className="site-footer__under">
               <div className="site-footer__utility">
                  <ul className="site-footer__utility__nav">
                     <li className="footer_util__list-item footer_util__list-item--depth-0"><a href="https://www.boisestate.edu/accessibility/" rel="noopener noreferrer" target='_blank' className="site-nav__action footer_util__action footer_util__action--depth-0">Accessibility</a></li>
                     <li className="footer_util__list-item footer_util__list-item--depth-0"><a href="https://www.boisestate.edu/privacy/" rel="noopener noreferrer" target='_blank' className="site-nav__action footer_util__action footer_util__action--depth-0">Privacy</a></li>
                     <li className="footer_util__list-item footer_util__list-item--depth-0"><a href="https://www.boisestate.edu/policy/" rel="noopener noreferrer" target='_blank' className="site-nav__action footer_util__action footer_util__action--depth-0">Policies</a></li>
                  </ul>
                  <p className="site-footer__copyright">
                     © { dt.getFullYear() } &nbsp;
                     All Rights Reserved. &nbsp;
                     <a target='_blank' rel="noopener noreferrer" href="https://www.boisestate.edu/">
                     Boise State University
                     </a>
                  </p>
               </div>
            </div>
         </div>
      </footer>
    );
  }
}

export default Footer;
